import jquery from 'jquery';
import 'bootstrap';

window.jquery = window.jQuery = window.$ = jquery;

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN' : $('meta[name="csrf"]').attr('content')
    }
})
